import styled from 'styled-components';
import { color } from '../../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
`;

export const HomePageStyledContainer = styled.div`
  background-color: tranparent;
  position: fixed;
  top: 40px;
  width: 100%;
  padding-left: 5px;
`;
